<template>
  <div class="activation-container mwow-form">
    <div class="full-screen-wrap" :class="{ active: fullScreen }">
      <p class="full-screen-total">
        <span style="margin-right: 24px">学员姓名：{{ studentInfo.name }}</span>
        <span>手机号码：{{ studentInfo.mobile }}</span>
      </p>
      <div class="form">
        <el-radio-group
          class="current-block-radio"
          v-model="currentBlock"
          v-show="!fullScreen"
          @change="
            (v) => {
              if (v === 1) {
                myChart.resize();
              }
            }
          "
        >
          <el-radio-button :label="1">可视化</el-radio-button>
          <el-radio-button :label="2">数据明细</el-radio-button>
        </el-radio-group>
        <i class="close el-icon-error" @click="handleFullScreen"></i>
        <date-range-selector
          @change="handleDateRangeChange"
        ></date-range-selector>
        <div class="date-step-selector" v-show="currentBlock === 1">
          <el-radio-group v-model="chartStep" @change="chartRender">
            <el-radio-button :label="1" v-if="dateRangeType > 2"
              >月</el-radio-button
            >
            <el-radio-button :label="2" v-if="dateRangeType > 1"
              >周</el-radio-button
            >
            <el-radio-button :label="3" v-if="dateRangeType < 3"
              >日</el-radio-button
            >
          </el-radio-group>
          <div
            class="mwow-button full-button large"
            @click="handleFullScreen"
            v-if="!fullScreen"
          >
            <i class="el-icon-full-screen"></i> 全屏查看
          </div>
        </div>
      </div>
      <div id="echart-wrap" v-show="currentBlock === 1"></div>
    </div>
    <div class="total-wrap" v-show="currentBlock === 2">
      <div class="total-head">
        综合活跃度
        <span class="mwow-green">{{ activationDetailData.total_score }}</span>
      </div>
      <div class="list">
        <div class="item">
          <p class="top">
            耗课活跃度
            <span class="mwow-green">{{
              activationDetailData.roll_call_consume_score
            }}</span>
          </p>
          <p class="mid">
            已耗课次数 {{ activationDetailData.roll_call_consume_count }}<br />
            耗课金额 ￥{{ activationDetailData.roll_call_consume_amount }}
          </p>
        </div>
        <div class="item">
          <p class="top">
            续费活跃度
            <span class="mwow-green">{{
              activationDetailData.renew_score
            }}</span>
          </p>
          <p class="mid">
            已续费数 {{ activationDetailData.renew_count }}<br />
            已续费金额 ￥{{ activationDetailData.renew_amount }}
          </p>
        </div>
        <div class="item">
          <p class="top">
            作业活跃度
            <span class="mwow-green">{{
              activationDetailData.homework_score
            }}</span>
          </p>
          <p class="mid">
            老师布置作业数 {{ activationDetailData.homework_count }}<br />
            已提交作业数 {{ activationDetailData.homework_submit_count }}
          </p>
        </div>
        <div class="item">
          <p class="top">
            APP活跃度
            <span class="mwow-green">{{
              activationDetailData.app_day_active_score
            }}</span>
          </p>
          <p class="mid">
            登录天数 {{ activationDetailData.app_day_active_count }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getStudentActivationDetailApi,
  getStudentActivationTotalApi,
} from "@/api/studyDetails";
import * as echarts from "echarts";
import dateRangeSelector from "./dateRangeSelector.vue";
import { throttle } from "@/utils/common";
export default {
  props: ["student-info", "visible"],
  components: {
    dateRangeSelector,
  },
  watch: {
    visible(n) {
      if (n) {
        if (this.myChart) {
          this.myChart.resize();
        }
        if (!this.inited) {
          this.handleSearch();
          this.inited = true;
        }
      }
    },
  },
  data() {
    return {
      inited: false,
      myChart: null,
      currentBlock: 1, // 展示可视化或图表
      activationData: [], // 活跃度数据
      dateRangeValueStart: "", // 开始时间
      dateRangeValueEnd: "", // 结束时间
      quickDateRange: "", // 快速时间选择
      chartStep: 3, // 图表按日|周|月展示
      activationDetailData: {
        app_day_active_count: 0,
        app_day_active_score: 0,
        app_launch_count: 0,
        homework_corrected_count: 0,
        homework_count: 0,
        homework_score: 0,
        homework_submit_count: 0,
        renew_amount: "0.00",
        renew_count: 0,
        renew_score: 0,
        roll_call_consume_amount: "0.00",
        roll_call_consume_count: 0,
        roll_call_consume_score: 0,
        total_score: 0,
      },
      fullScreen: false,
      dateRangeType: 0, // 时间选择组件回调的时间类型：周1月2年3
      currentDataKey: "综合活跃度", // 当前展示数据
      chartsResizeWatcher: null,
    };
  },
  mounted() {
    this.chartsResizeWatcher = throttle(() => {
      this.myChart.resize();
    }, 600);
    window.addEventListener("resize", this.chartsResizeWatcher);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.chartsResizeWatcher);
  },
  methods: {
    handleSearch() {
      if (!this.dateRangeValueStart || !this.dateRangeValueEnd) {
        return false;
      }
      // 同时更新两个数据
      getStudentActivationDetailApi({
        student_id: this.studentInfo.id,
        start_date: this.dateRangeValueStart,
        end_date: this.dateRangeValueEnd,
      }).then((res) => {
        this.activationData = res.data.list.reverse();
        this.chartRender();
      });
      getStudentActivationTotalApi({
        student_id: this.studentInfo.id,
        start_date: this.dateRangeValueStart,
        end_date: this.dateRangeValueEnd,
      }).then((res) => {
        this.activationDetailData = res.data;
      });
    },
    chartRender() {
      let data = this.activationData;
      let total_score_Y = [];
      let roll_call_consume_score_Y = [];
      let renew_score_Y = [];
      let homework_score_Y = [];
      let app_day_active_score_Y = [];
      let date_X = [];
      if (this.chartStep === 1) {
        // 按月
        let total_score_total = 0;
        let roll_call_consume_score_total = 0;
        let renew_score_total = 0;
        let homework_score_total = 0;
        let app_day_active_score_total = 0;
        data.map((date, index) => {
          if (index === 0) {
            date_X.push(date.date.slice(0, 7));
          } else {
            if (new Date(date.date).getDate() === 1) {
              date_X.push(date.date.slice(0, 7));
            }
          }
          total_score_total = total_score_total + date.total_score;
          roll_call_consume_score_total =
            roll_call_consume_score_total + date.roll_call_consume_score;
          renew_score_total = renew_score_total + date.renew_score;
          homework_score_total = homework_score_total + date.homework_score;
          app_day_active_score_total =
            app_day_active_score_total + date.app_day_active_score;
          if (
            index === data.length - 1 ||
            new Date(data[index + 1].date).getDate() === 1
          ) {
            // 结算累计
            total_score_Y.push(total_score_total);
            total_score_total = 0;
            roll_call_consume_score_Y.push(roll_call_consume_score_total);
            roll_call_consume_score_total = 0;
            renew_score_Y.push(renew_score_total);
            renew_score_total = 0;
            homework_score_Y.push(homework_score_total);
            homework_score_total = 0;
            app_day_active_score_Y.push(app_day_active_score_total);
            app_day_active_score_total = 0;
          }
        });
      }
      if (this.chartStep === 2) {
        // 按周
        let total_score_total = 0;
        let roll_call_consume_score_total = 0;
        let renew_score_total = 0;
        let homework_score_total = 0;
        let app_day_active_score_total = 0;
        data.map((date, index) => {
          if (index === 0) {
            date_X.push(date.date);
          } else {
            if (new Date(date.date).getDay() === 1) {
              date_X.push(date.date);
            }
          }
          total_score_total = total_score_total + date.total_score;
          roll_call_consume_score_total =
            roll_call_consume_score_total + date.roll_call_consume_score;
          renew_score_total = renew_score_total + date.renew_score;
          homework_score_total = homework_score_total + date.homework_score;
          app_day_active_score_total =
            app_day_active_score_total + date.app_day_active_score;
          if (
            index === data.length - 1 ||
            new Date(data[index + 1].date).getDay() === 1
          ) {
            // 结算累计
            total_score_Y.push(total_score_total);
            total_score_total = 0;
            roll_call_consume_score_Y.push(roll_call_consume_score_total);
            roll_call_consume_score_total = 0;
            renew_score_Y.push(renew_score_total);
            renew_score_total = 0;
            homework_score_Y.push(homework_score_total);
            homework_score_total = 0;
            app_day_active_score_Y.push(app_day_active_score_total);
            app_day_active_score_total = 0;
          }
        });
      }
      if (this.chartStep === 3) {
        // 按日
        data.map((date) => {
          total_score_Y.push(date.total_score);
          roll_call_consume_score_Y.push(date.roll_call_consume_score);
          renew_score_Y.push(date.renew_score);
          homework_score_Y.push(date.homework_score);
          app_day_active_score_Y.push(date.app_day_active_score);
          date_X.push(date.date);
        });
      }
      let chartDom = document.getElementById("echart-wrap");
      this.myChart = echarts.init(chartDom);
      let option = {
        tooltip: {
          trigger: "axis",
        },
        legend: {
          bottom: 0,
          data: [
            "综合活跃度",
            "耗课活跃度",
            "续费活跃度",
            "作业活跃度",
            "APP使用活跃度",
          ],
          selected: {
            综合活跃度: this.currentDataKey === "综合活跃度",
            耗课活跃度: this.currentDataKey === "耗课活跃度",
            续费活跃度: this.currentDataKey === "续费活跃度",
            作业活跃度: this.currentDataKey === "作业活跃度",
            APP使用活跃度: this.currentDataKey === "APP使用活跃度",
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "50px",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: date_X,
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: "综合活跃度",
            type: "line",
            data: total_score_Y.map((n) => {
              return Number(n).toFixed(2);
            }),
          },
          {
            name: "耗课活跃度",
            type: "line",
            data: roll_call_consume_score_Y.map((n) => {
              return Number(n).toFixed(2);
            }),
          },
          {
            name: "续费活跃度",
            type: "line",
            data: renew_score_Y.map((n) => {
              return Number(n).toFixed(2);
            }),
          },
          {
            name: "作业活跃度",
            type: "line",
            data: homework_score_Y.map((n) => {
              return Number(n).toFixed(2);
            }),
          },
          {
            name: "APP使用活跃度",
            type: "line",
            data: app_day_active_score_Y.map((n) => {
              return Number(n).toFixed(2);
            }),
          },
        ],
      };
      option && this.myChart.setOption(option);
      this.myChart.on("legendselectchanged", (params) => {
        let dic = {};
        for (let key in params.selected) {
          dic[key] = false;
        }
        option.legend.selected = dic;
        option.legend.selected[params.name] = true;
        this.currentDataKey = params.name;
        this.myChart.setOption(option);
      });
    },
    handleDateRangeChange(data) {
      this.dateRangeValueStart = data.dates[0];
      this.dateRangeValueEnd = data.dates[1];
      this.dateRangeType = data.type;
      switch (data.type) {
        case 1:
          this.chartStep = 3;
          break;
        case 2:
          this.chartStep = 2;
          break;
        case 3:
          this.chartStep = 1;
          break;
      }
      if (!this.visible) {
        return false;
      }
      this.handleSearch();
    },
    handleFullScreen() {
      this.fullScreen = !this.fullScreen;
      this.$nextTick(() => {
        this.myChart.resize();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.activation-container {
  background-color: #fff;
  padding: 13px;
  .full-screen-wrap {
    background-color: #fff;
    .full-screen-total {
      display: none;
      font-size: 16px;
      line-height: 16px;
      color: #5c5d5e;
      margin-bottom: 24px;
      margin: 40px 60px;
    }
    .close {
      display: none;
      position: absolute;
      top: 24px;
      right: 24px;
      font-size: 24px;
      cursor: pointer;
      color: #999;
    }
    .form {
      /deep/.current-block-radio {
        display: inline-block;
        vertical-align: top;
        margin-right: 12px;
        margin-bottom: 24px;
        .el-radio-button__inner {
          font-size: 12px !important;
          line-height: 14px !important;
        }
      }
      /deep/.date-range-selector {
        display: inline-flex;
        vertical-align: top;
        margin-right: 12px;
        .range-wrap {
          .el-date-editor {
            width: 140px !important;
          }
        }
        .buttons-wrap {
        }
      }
      /deep/.date-step-selector {
        display: inline-block;
        vertical-align: top;
        margin-top: 2px;
        .el-radio-group {
          .el-radio-button__inner {
            padding: 4px 18px !important;
          }
        }
        .full-button {
          margin-left: 12px;
          height: 22px !important;
          line-height: 22px !important;
        }
      }
    }
    #echart-wrap {
      width: 100%;
      height: 360px;
    }
    &.active {
      position: fixed;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      z-index: 100;
      overflow: hidden auto;
      .full-screen-total {
        display: block;
      }
      .close {
        display: block;
      }
      .form {
        margin: 0 60px;
      }
      #echart-wrap {
        margin: 0 60px 40px 60px;
        width: calc(100vw - 120px);
        height: calc(100vh - 200px);
      }
    }
  }
  .total-wrap {
    .total-head {
      background-color: #f6fafc;
      border-radius: 10px;
      margin-block: 7px;
      font-size: 15px;
      line-height: 15px;
      color: #5c5d5e;
      padding: 22px 0 22px 33px;
    }
    .list {
      display: flex;
      .item {
        flex: 1;
        border-radius: 10px;
        background-color: #f6fafc;
        margin-right: 6px;
        font-size: 12px;
        line-height: 24px;
        &:last-child {
          margin-right: 0;
        }
        .top {
          color: #5c5d5e;
          padding: 10px 0 10px 33px;
        }
        .mid {
          background-color: #fbfdfe;
          color: #a2a5a8;
          padding: 10px 0 10px 33px;
        }
      }
    }
  }
}
</style>
